import { DescripcionDetallePersona } from "./DescripcionDetallePersona";
import { AsignarSupervisor } from "./AsignarSupervisor";
import { IInfoPersona } from "../../Interfaces/IPersona";
import { Checkbox, Toggle } from "@fluentui/react";
import { useEffect, useState } from "react";
import personaServicio from "../../services/persona/personaServicio";
import { EsEnrolado } from "./EsEnrolado";


export const InfoPersona = (props: IInfoPersona) => {

  console.log("++++++++++ info ++++++++++")
  const [exoneraSAP, setExoneraSAP] = useState<boolean | undefined>(false)

  console.log(props.datosPersona)

  useEffect(() => {
    setExoneraSAP(props.datosPersona?.exoneraSAP)
    // ObtenerEnroll();
  }, [props])


  const ActualizaPersonaAPI = (data: {}) => {

    personaServicio
      .ActualizarPersona(data)
      .then((res) => {


        //setinfoPersona(persona.data);
      })
      .catch((err) => {
        alert(err.message);
      });



  };

  // const ObtenerEnroll = () => {
  //   const data = props.usuarioId;
  //   if (data) { 
  //     personaServicio
  //       .ObtenerEnroll(data)
  //       .then((res) => {
  //       })
  //       .catch((err) => {
  //         alert(err.message);
  //       });
  //   } else {
  //     alert("Usuario ID no disponible");
  //   }
  // };

  function _onChange(ev?: React.FormEvent<HTMLElement | HTMLInputElement>, isChecked?: boolean) {

    console.log(isChecked)


    setExoneraSAP(isChecked)

    let update = {
      personaId: props.personaId,
      ExoneraSAP: isChecked
    }

    ActualizaPersonaAPI(update)
  }




  return (
    <div className="ms-Grid" dir="ltr">
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12 ms-md2 ms-lg3">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12 ms-lg12">
              <div
                style={{
                  width: 180,
                  height: 180,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              >
                <img
                  src={props.datosPersona?.foto}
                  alt="Foto"
                  style={{ borderRadius: "50%", width: 180, height: 180 }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg9">
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
              <div>
                <DescripcionDetallePersona
                  label="Persona:"
                  placeholder={`${props.datosPersona?.primerNombre} ${props.datosPersona?.apellidoPaterno} ${props.datosPersona?.apellidoMaterno}`}
                />
                <DescripcionDetallePersona
                  label="Doc. Identidad:"
                  placeholder={`${props.datosPersona?.tipoDocumentoIdentidad} / ${props.datosPersona?.nroDOI}`}
                />
                <DescripcionDetallePersona
                  label="Email:"
                  placeholder={props.datosPersona?.email}
                />
                <DescripcionDetallePersona
                  label="Celular:"
                  placeholder={props.datosPersona?.celular}
                />
              </div>
              <AsignarSupervisor
                checked={false}
                disabled={false}
                supervisor={props.nombreSupervisor}
                personaId={props.personaId}
                reload={props.reload}
              />
            </div>
            <div className="ms-Grid-col ms-sm6 ms-md6 ms-lg6">
              <div>
                <DescripcionDetallePersona
                  label="Empresa:"
                  placeholder={props.datosPersona?.empresa}
                />
                <DescripcionDetallePersona
                  label="Guardia:"
                  placeholder={props.datosPersona?.guardia}
                />
                <DescripcionDetallePersona
                  label="Área:"
                  placeholder={props.datosPersona?.area}
                />
                <DescripcionDetallePersona
                  label="Cargo:"
                  placeholder={props.datosPersona?.puesto}
                />
                <EsEnrolado
                  checked={false}
                  disabled={false}
                  supervisor={props.nombreSupervisor}
                  personaId={props.personaId}
                  dataPersona={props.datosPersona}
                  reload={props.reload}
                />
             <br />
                <Toggle
                  label='¿Exonera Supervisor SAP?'
                  onText='SI' offText='NO'
                  checked={exoneraSAP}
                  onChange={_onChange}
                />



              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
